<template>
    <div class="box">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <div style="display: flex;align-items: center">
                <span class="el-icon-back" style="font-size: 30px;margin-right: 15px;cursor:pointer" @click="handleBack"></span>
                <el-breadcrumb-item>设备应用类型管理</el-breadcrumb-item>
            </div>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <h1 style="text-align: left;color: #666">当前设备：{{deviceName}}</h1>
        <!-- 搜索筛选 -->
        <el-form :inline="true"  class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item>
                <el-button  type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%"   highlight-current-row
            :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column prop="CategoryName" label="类型名称" sortable width="180">
            </el-table-column>
            <!-- <el-table-column prop="Color" label="颜色" sortable width="300">
                <template slot-scope="scope">
                    <div style="display: flex;align-items: center">
                            <span style="margin-right: 10px;">{{scope.row.Color}}</span>
                            <span :style="{backgroundColor: scope.row.Color}" style="display:inline-block;width:30px;height: 30px"></span>
                    </div>
                    </template>
                </el-table-column> -->
            <el-table-column prop="CategorySort" label="排序" sortable width="80">
            </el-table-column>
            <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)" v-if="scope.row.CategoryName!='常用应用'">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-if="scope.row.CategoryName!='常用应用'">删除</el-button>
                </template>
        </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination background @current-change="handleCurrentChange" :current-page="model.Page" layout="total,prev, pager, next, jumper" :total="listCount" :page-size="model.Rows">
            </el-pagination>
        </el-row>
        <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd" :CompanyCode="CompanyCode" :DeviceCode="DeviceCode"></add>
        <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData"></edit>
    </div>
</template>

<script>
    import {GetDACategorylist,DeleteDACategorylist} from '../../../api/device'
    import add from './add'
    import edit from './edit'
    export default {
        components: {
            add,
            edit
        },
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                listCount: null,
                dataList: [],
                editData: [],
                model: {
                    Page: 1,
                    Rows: 10,
                    CompanyCode:'',
                    DeviceCode: ''
                }
            }
        },
        props: {
            deviceName: {
                required: true,
            },
            CompanyCode: {
                required: true
            },
            DeviceCode: {
                required: true
            }
        },
        filters: {
            filterLogo(logo) {
                if(logo) {
                    return logo.split()
                }
            },
            filterImgs(images) {
                if(typeof(images)==='string') {
                    if(images.indexOf('|')!=-1) {
                        return images.split('|');
                    }else{
                        return images.split(' ');
                    }  
                }
            }
        },
        mounted() {
            this.model.DeviceCode = this.DeviceCode;
            this.model.CompanyCode = this.CompanyCode;
            this.GetDACategorylist();
        },
        methods: {
            GetDACategorylist() {
                GetDACategorylist(this.model).then(data=>{
                    if(!data.iserror) {
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
            handleDelete(row) {
                let id = row.OID;
                this.$confirm('确认删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.DeleteDACategorylist(id);
                })
            },
            handleCloseEdit() {
                this.isShowEdit = false;
                this.GetDACategorylist();
            },
            handleCloseAdd() {
                this.isShowAdd = false; 
                this.GetDACategorylist();
            },
            DeleteDACategorylist(id) {
                DeleteDACategorylist({OID: id}).then(data=>{
                    if(!data.iserror) {
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.GetDACategorylist();
                    }
                })
            },
            handleBack() {
                this.$emit('showDevice')
            },
            handleCurrentChange(val) {
                this.model.Page = val;
                this.GetDeviceAppList();
            },
        }
    }
</script>

<style>
.el-icon-circle-close:before {
    color: #ffffff;
}
</style>